const initialSrore = [
  {
    id: "42630d2c-870d-4001-bfd6-f5c504cb9e01",
    title: "iPhone 15 launch event",
    description:
      "Apple always holds an event in September, and almost always uses this to announce a new iPhone. (The only exception in recent memory was in 2020, as a result of Covid-related production issues.",
    date: 12,
    month: 8,
    time: "19:00",
    location: "Online",
    category: "Business",
    addPicture:
      "https://event-planner-rosy.vercel.app/static/media/conference.55c90d5157a89bdcf16c.jpg",
    priority: "Low",
  },
  {
    id: "6d6a3cc1-f9fb-4020-a922-85b018a63e0a",
    title: "RBS Six Nations Rugby",
    description:
      "The Six Nations Championship for England, France, Ireland, Italy, Scotland and Wales will see matches take place at venues including the Principality Stadium in Cardiff, Twickenham Stadium in London, and Murrayfield Stadium in Edinburgh. ",
    date: 2,
    month: 1,
    time: "12:00",
    location: "London",
    category: "Sport",
    addPicture:
      "https://event-planner-rosy.vercel.app/static/media/sport.5ca4f3bc53630885c229.jpg",
    priority: "Medium",
  },
  {
    id: "98a24e4a-4e29-4a33-b9a5-97e252d40676",
    title: "Coronation of King Charles III",
    description:
      "Charles III will be crowned king at Westminster Abbey by the Archbishop of Canterbury on May 6, marking the first coronation of a British monarch in the 21st century and the first since Queen Elizabeth II in 1953. ",
    date: 25,
    month: 11,
    time: "10:00",
    location: "Norfolk",
    category: "Conference",
    addPicture:
      "https://event-planner-rosy.vercel.app/static/media/workshop.ece755a9653d80be80bd.jpg",
    priority: "High",
  },
  {
    id: "4c173f9d-a33e-4f39-a4ae-863a0de7c89a",
    title: "Burning Man",
    description:
      "The only way to describe Burning Man is to experience yourself in person. See you on the playa!",
    date: 27,
    month: 7,
    time: "12:00",
    location: "USA",
    category: "Music",
    addPicture:
      "https://event-planner-rosy.vercel.app/static/media/music.9e6072212b814af3261d.jpg",
    priority: "High",
  },
];

export default initialSrore;
